import { Alert, Button, Icon, InputField, Option, Select } from '@profitowi/component-library';
import { AxiosError } from 'axios';
import { useField, useFormikContext } from 'formik';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';

import { sendSummaryVerification } from 'services/summary';

const CODE_COMMUNICATION_TYPES: Option[] = [
  { key: 'SMS', value: 'Kod SMS' },
  { key: 'EMAIL', value: 'Kod e-mail' },
];

type Props = {
  agentId: number;
  assessmentId: number;
  summaryHtml: string;
  isValidateCodeError?: boolean;
  onCommunicationTypeChange?: (type: Option) => void;
};

const SummaryAuthCode = ({
  agentId,
  assessmentId,
  summaryHtml,
  isValidateCodeError,
  onCommunicationTypeChange,
}: Props) => {
  const [communicationType, setCommunicationType] = useState<Option>(CODE_COMMUNICATION_TYPES[0]);
  const [field, meta] = useField('summaryVerificationCode');
  const { setFieldValue } = useFormikContext();
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [isRefetch, setIsRefetch] = useState(false);

  useEffect(() => {
    onCommunicationTypeChange?.(CODE_COMMUNICATION_TYPES[0]);
  }, []);

  const { error, touched } = meta;

  const sendMutation = useMutation<unknown, AxiosError>(
    () =>
      sendSummaryVerification(
        agentId,
        assessmentId,
        communicationType.key.toString() as 'SMS' | 'EMAIL',
        'CODE',
        summaryHtml
      ),
    {
      onSuccess: () => {
        setIsCodeSent(true);
        setIsRefetch(true);
        setFieldValue('summaryVerificationCode', '');
      },
    }
  );

  return (
    <div className="space-y-4 w-full pt-4">
      <p className="font-semibold text-primary">Autoryzacja analizy kodem</p>
      {sendMutation.isError && (
        <Alert type="error" className="mb-4">
          Wystąpił błąd przy wysyłaniu kodu
        </Alert>
      )}
      <div className="flex items-center space-x-4">
        <Select
          selected={communicationType}
          options={CODE_COMMUNICATION_TYPES}
          setSelected={(value: Option) => {
            setCommunicationType(value);
            onCommunicationTypeChange?.(value);
            setIsCodeSent(false);
            setFieldValue('summaryCommunicationType', value.key);
            setFieldValue('summaryVerificationCode', '');
          }}
        />
        <Button size="sm" onPress={() => sendMutation.mutate()} isDisabled={sendMutation.isLoading}>
          {isRefetch ? 'Wyślij ponownie' : 'Wyślij'}
          <Icon name="send" className="ml-2 text-md" />
        </Button>
      </div>
      {isValidateCodeError && (
        <Alert type="error" className="mb-4">
          Podany kod jest błędny
        </Alert>
      )}
      <InputField
        name="summaryVerificationCode"
        label="Wpisz kod"
        maxLength={6}
        validationState={error && touched ? 'invalid' : 'valid'}
        isRequired
      />
    </div>
  );
};

export default SummaryAuthCode;
